import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { projetosApi } from '../api/projetos.js';
import { VazioQueEnsina } from '../componentes/transversais/VazioQueEnsina.js';

export function Projetos() {
  const { data: projetos, isLoading } = useQuery({ queryKey: ['projetos'], queryFn: projetosApi.listar });

  return (
    <div className="flex flex-col gap-6 p-8">
      <h1 className="text-xl font-semibold text-ink">Projetos</h1>

      {isLoading && <p className="text-sm text-grafite">Carregando…</p>}

      {!isLoading && (!projetos || projetos.length === 0) && (
        <VazioQueEnsina explicacao="Nenhum projeto instanciado. Projetos nascem de uma demanda AutorizadaExecucao." />
      )}

      {projetos && projetos.length > 0 && (
        <ul className="flex flex-col gap-2">
          {projetos.map((projeto) => (
            <li key={projeto.id}>
              <Link to={`/projetos/${projeto.id}`} className="block rounded border border-borda bg-superficie px-4 py-3 hover:border-aco">
                <p className="text-sm text-ink">{projeto.id}</p>
                <p className="fonte-mono text-xs text-grafite">
                  {projeto.estado} · gerente {projeto.gerente}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
